function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("path", {
  d: "M4.877 3.249c0 4.937 2.703 11.157 5.143 15.776h10.394c.638 0 .866-1.005.599-1.514-.525-.997-3.383-2.423-8.841-1.845-2.629-5.126-3.328-8.164-3.328-8.164s.2-3.496-.395-4.531c-.427-.743-3.572-.705-3.572.278zM12.366 19.033c.995 2.07 1.57 3.275 2.409 4.689M10.996 23.833h7.857",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var _ref3 = React.createElement("path", {
  d: "M9.772 13.35c2.185-.976 5.51-1.197 8.508-.527",
  stroke: "#004152",
  strokeWidth: 1.5,
  strokeLinecap: "round"
});

var SvgTravelClass = function SvgTravelClass(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTravelClass, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/travel-class.775eadd0.svg";
export { ForwardRef as ReactComponent };